// Maximum combined outbound attachment bytes accepted on one conversation message.
export const outboundAttachmentMaxTotalBytes = 10 * 1024 * 1024
